import { render } from "./StatLayout.vue?vue&type=template&id=32e9b51a&scoped=true"
import script from "./StatLayout.vue?vue&type=script&lang=js"
export * from "./StatLayout.vue?vue&type=script&lang=js"

import "./StatLayout.vue?vue&type=style&index=0&id=32e9b51a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32e9b51a"

export default script